import { Component } from '@angular/core';

@Component({
  selector: 'app-chain-level-layout',
  templateUrl: './chain-level-layout.component.html',
  styleUrls: ['./chain-level-layout.component.scss']
})
export class ChainLevelLayoutComponent {

}
